import { settings } from '../settings/settings-util';

function calculateXPosition() {
    const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    const xPos = settings.Window.defaultPosition.xPos;
    const bufferedAgentWidth = parseInt(settings.Window.defaultSize.width, 10) + parseInt(xPos, 10);

    const bufferSize = 10;

    if (windowWidth <= (bufferedAgentWidth + bufferSize)) {
        return bufferSize;
    }
    return windowWidth - bufferedAgentWidth + "px";
}

function calculateYPosition() {
    const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    const yPos = settings.Window.defaultPosition.yPos;
    const bufferedAgentHeight = parseInt(settings.Window.defaultSize.height, 10) + parseInt(yPos, 10);

    const bufferSize = 10;

    if (windowHeight <= (bufferedAgentHeight + bufferSize)) {
        return bufferSize;
    }
    return windowHeight - bufferedAgentHeight + "px";
}

function setupDefaultState(components) {
    const convoState = {
        [settings.stateLocations.Conversation.customSessionId]: null,
        [settings.stateLocations.Conversation.inputProcessing]: [],
        [settings.stateLocations.Conversation.processedInput]: [],
        [settings.stateLocations.Conversation.processedResponse]: null,
        [settings.stateLocations.Conversation.receivedResponse]: null,
        [settings.stateLocations.Conversation.sentInput]: null,
        [settings.stateLocations.Conversation.sessionId]: null,
        [settings.stateLocations.Conversation.userId]: null,
        [settings.stateLocations.Conversation.language]: settings.languageConstants.languages[settings.languageConstants.default],
        [settings.stateLocations.Conversation.channel]:
            components.mobileDeviceDetector.getDeviceType() === settings.mobileConstants.deviceTypes.desktop ?
                settings.channelConstants.channels.Web : settings.channelConstants.channels.MobileWeb,
    };

    return {
        [settings.stateLocations.Conversation.Base]: convoState,
        [settings.stateLocations.DeviceType]: settings.mobileConstants.deviceTypes.deviceDefault,
        [settings.stateLocations.History.Base]: {
            [settings.stateLocations.History.Messages]: [],
            [settings.stateLocations.History.RawMessages]: [],
        },
        [settings.stateLocations.PersistentStorage.Base]: {
        },
        [settings.stateLocations.Window.Base]: {
            [settings.stateLocations.Window.AlmeMessage.Base]: {
                [settings.stateLocations.Window.AlmeMessage.shouldDisable]: false,
            },
            [settings.stateLocations.Window.CallToActionButton.Base]: {
                [settings.stateLocations.Window.CallToActionButton.shouldDisable]: {},
            },
            [settings.stateLocations.Window.DisplayLinks.Base]: {
                [settings.stateLocations.Window.DisplayLinks.shouldDisable]: false,
            },
            [settings.stateLocations.Window.DisplayLinksUrl.Base]: {
                [settings.stateLocations.Window.DisplayLinksUrl.shouldDisable]: false,
            },
            [settings.stateLocations.Window.currentTree]: null,
            [settings.stateLocations.Window.InlineSurveyLinks.Base]: {
                [settings.stateLocations.Window.InlineSurveyLinks.shouldDisable]: {},
            },
            [settings.stateLocations.Window.Input.Base]: {
                [settings.stateLocations.Window.Input.CurrentInput]: null,
                [settings.stateLocations.Window.Input.StageLocation]: null,
            },
            [settings.stateLocations.Window.InputBoxLocked.Base]: {
                [settings.stateLocations.Window.InputBoxLocked.isInputBoxLocked]: false,
                [settings.stateLocations.Window.InputBoxLocked.ReenableOnLinkClick]: true,
            },
            [settings.stateLocations.Window.isDragging]: false,
            [settings.stateLocations.Window.IsMinimized]: true,
            [settings.stateLocations.Window.MinimizeButton.Base]: {
                [settings.stateLocations.Window.MinimizeButton.shouldDisable]: false,
            },
            [settings.stateLocations.Window.NavUrl.Base]: {
                [settings.stateLocations.Window.NavUrl.shouldDisable]: false,
            },
            [settings.stateLocations.Window.position]: {
                "xPos": calculateXPosition(),
                "yPos": calculateYPosition(),
            },
            [settings.stateLocations.Window.ReportingEvent.Base]: {
                [settings.stateLocations.Window.ReportingEvent.StageLocation]: null,
            },
            [settings.stateLocations.Window.size]: {
                "height": settings.Window.defaultSize.height,
                "width": settings.Window.defaultSize.width,
            },
            [settings.stateLocations.Window.SkipToContent.Base]: {
                [settings.stateLocations.Window.SkipToContent.shouldDisable]: false,
                [settings.stateLocations.Window.SkipToContent.ShouldSkipToContent]: false,
            },
            [settings.stateLocations.Window.TimeoutWarning.Base]: {
                [settings.stateLocations.Window.TimeoutWarning.SessionStartTime]: null,
                [settings.stateLocations.Window.TimeoutWarning.Visible]: false,
            },
            [settings.stateLocations.Window.UserMessage.Base]: {
                [settings.stateLocations.Window.UserMessage.shouldDisable]: false,
            },
            [settings.stateLocations.Window.WindowForm.Base]: {
                [settings.stateLocations.Window.WindowForm.shouldDisable]: false,
                [settings.stateLocations.Window.WindowForm.Counter]: 0,
            },
        },
        [settings.stateLocations.ClientCommunicator.Base]: {
            [settings.stateLocations.ClientCommunicator.ReceivedMessages]: [],
            [settings.stateLocations.ClientCommunicator.AllowedOrigins]: process.env.allowed_origins,
        },
        [settings.stateLocations.AutoNav.Base]: {},
        [settings.stateLocations.WelcomeUser.Base]: {},
        [settings.stateLocations.CommandAction.Base]: {
            [settings.stateLocations.CommandAction.PageLoadActions]: [],
        },
        [settings.stateLocations.Survey.Base]: {
            [settings.stateLocations.Survey.Comment]: "",
            [settings.stateLocations.Survey.Reason]: "",
            [settings.stateLocations.Survey.MetaData]: {},
            [settings.stateLocations.Survey.EntryId]: "",
            [settings.stateLocations.Survey.SelectedReasonIndex]: "",
            [settings.stateLocations.Survey.SurveyId]: "",
            [settings.stateLocations.Survey.SurveyUnitLabel]: "",
            [settings.stateLocations.Survey.Visible]: false,
        },
    };

}

export {
    setupDefaultState,
};



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/wireup/default-state.js